import React from 'react';
import { ToastContainer } from 'react-toastify';
import AdminChrome from '../../AdminShared/AdminChrome';
import DomainRules from '../components/DomainRules';

const DomainRulesApp = ({ chrome = {}, ...props }) => (
  <AdminChrome {...chrome}>
    <div className="adash-body">
      <DomainRules {...props} />
    </div>
    <ToastContainer icon={false} />
  </AdminChrome>
);

export default DomainRulesApp;
